import ky from 'ky';

const umbraco = ky.create({
    retry: {
        limit: 0,
    },
});

export default umbraco;
